<nz-avatar [nzSize]="size"  style="font-size:{{fontSize}}px; background-color: {{color}}" [nzText]="text"></nz-avatar>
